// extracted by mini-css-extract-plugin
export var checkbox = "_7e-0";
export var circle = "_7e-3";
export var horizontalContainer = "_7e-7";
export var sm = "_7e-5";
export var switch0 = "_7e-2";
export var switchDisabled = "_7e-8";
export var switchEnabled = "_7e-1";
export var textSwitchContainer = "_7e-9";
export var textSwitchOption = "_7e-a";
export var textSwitchOptionSelected = "_7e-b";
export var verticalContainer = "_7e-6";
export var xs = "_7e-4";